const UPDATE_BONDS = 'UPDATE_BONDS';
const REMOVE_BONDS = 'REMOVE_BONDS';
const UPDATE_CLOSED_BONDS = 'UPDATE_CLOSED_BONDS';

const initialState = {
  bonds: [],
  closedBonds: [],
};

const bondsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BONDS:
      return {
        ...state,
        bonds: action.payload,
      };
    case UPDATE_CLOSED_BONDS:
      return {
        ...state,
        closedBonds: action.payload,
      };
    case REMOVE_BONDS:
      return {
        bonds: [],
        closedBonds: [],
      };

    default:
      return state;
  }
};

export default bondsReducer;

export const updateBonds = (bonds) => ({
  type: UPDATE_BONDS,
  payload: bonds,
});

export const updateClosedBonds = (bonds) => ({
  type: UPDATE_CLOSED_BONDS,
  payload: bonds,
});
export const removeBonds = () => ({
  type: REMOVE_BONDS,
});
